import Api from '@/services/Api'

export default {
  getUsers (payload) {
    return Api().post('admin', payload)
  },
  getUserCreatedPrivate (payload) {
    return Api().post('admin/chips', payload)
  },
  editUsers (payload) {
    return Api().post('admin/users', payload)
  },
  toggleEmail (payload) {
    return Api().post('admin/email', payload)
  }
}
